import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { Configuration } from '@pixacare/domain';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Cacheable } from 'ts-cacheable';

@Injectable({
  providedIn: 'root',
})
export class AppConfigHttpService {
  private readonly http = inject(HttpClient);

  private readonly _config$: WritableSignal<Configuration | null> = signal(null);

  get configuration(): Configuration {
    const config = this._config$();
    if (!config) {
      throw new Error('Configuration not loaded. Call getAppConfig() first.');
    }
    return config;
  }

  @Cacheable()
  getAppConfig(): Observable<Configuration> {
    return this.http
      .get<Configuration>(`${environment.apiBaseUrl}/Configuration`)
      .pipe(tap((config) => this._config$.set(config)));
  }
}
